module.exports = "/_next/static/images/bank-bca-icon-e18a764e30f53785880abe442cbc2f0b.svg";